<script>
export default {
	name: 'IconSvgWav',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.3714 4.10333C12.9067 4.10289 12.4612 3.92171 12.1326 3.59956C11.804 3.2774 11.6192 2.84059 11.6187 2.385V1.54851e-07H3.78809C3.48765 -0.000109306 3.19013 0.057814 2.91254 0.170461C2.63494 0.283108 2.3827 0.448273 2.17022 0.65652C1.95774 0.864766 1.78919 1.11201 1.67419 1.38414C1.5592 1.65627 1.5 1.94794 1.5 2.2425V15.7608C1.5009 16.3551 1.74239 16.9248 2.17142 17.3447C2.60044 17.7645 3.18192 18.0002 3.78809 18H13.1886C13.489 18 13.7864 17.942 14.0639 17.8293C14.3414 17.7166 14.5936 17.5514 14.8059 17.3432C15.0183 17.135 15.1868 16.8877 15.3017 16.6157C15.4167 16.3436 15.4759 16.052 15.4759 15.7575V4.10333H13.3714Z"
				:fill="color" />
			<path
				d="M15.4759 4.10333H13.3714C12.9067 4.10289 12.4612 3.92171 12.1326 3.59956C11.804 3.2774 11.6192 2.84059 11.6188 2.385V0L15.4759 4.10333Z"
				fill="#0055A3" />
			<path
				d="M17.135 14.2166H6.50712C5.75323 14.2166 5.14209 14.8157 5.14209 15.5549V18.6615C5.14209 19.4007 5.75323 19.9999 6.50712 19.9999H17.135C17.8889 19.9999 18.5 19.4007 18.5 18.6615V15.5549C18.5 14.8157 17.8889 14.2166 17.135 14.2166Z"
				fill="#0055A3" />
			<path d="M7.56446 17.7809V18.3867H6.92444V17.7809H7.56446Z" fill="#F3F3F6" />
			<path
				d="M11.3605 15.8809L10.7493 18.3867H9.98438L9.5764 16.71L9.16417 18.3867H8.39921L7.78809 15.8809H8.46041L8.78934 17.6959L9.23812 15.8809H9.91808L10.3669 17.6959L10.6992 15.8809H11.3605Z"
				fill="#F3F3F6" />
			<path
				d="M13.2693 17.9291H12.3105L12.1516 18.3867H11.5013L12.4363 15.8983H13.1486L14.0835 18.3867H13.4256L13.2693 17.9291ZM13.1095 17.4683L12.7916 16.5475L12.4703 17.4683H13.1095Z"
				fill="#F3F3F6" />
			<path
				d="M14.8018 15.8809L15.4273 17.7667L16.0529 15.8809H16.7142L15.8251 18.3867H15.0262L14.1405 15.8809H14.8018Z"
				fill="#F3F3F6" />
			<path
				d="M11.7191 10.9934H10.7841V7.30505C10.7841 7.1815 10.7341 7.06302 10.645 6.97565C10.5559 6.88829 10.435 6.83922 10.309 6.83922H7.92914C7.80313 6.83922 7.68227 6.88829 7.59317 6.97565C7.50407 7.06302 7.45401 7.1815 7.45401 7.30505V10.9934H6.52332V6.99338C6.52332 6.71004 6.63812 6.43831 6.84246 6.23796C7.04681 6.0376 7.32396 5.92505 7.61296 5.92505H10.6227C10.9117 5.92505 11.1888 6.0376 11.3932 6.23796C11.5975 6.43831 11.7123 6.71004 11.7123 6.99338L11.7191 10.9934Z"
				fill="#0055A3" />
			<path
				d="M10.6158 12.075C11.2251 12.075 11.7191 11.5907 11.7191 10.9933C11.7191 10.3959 11.2251 9.91162 10.6158 9.91162C10.0065 9.91162 9.51257 10.3959 9.51257 10.9933C9.51257 11.5907 10.0065 12.075 10.6158 12.075Z"
				fill="#0055A3" />
			<path
				d="M6.36093 12.075C6.97024 12.075 7.46418 11.5907 7.46418 10.9933C7.46418 10.3959 6.97024 9.91162 6.36093 9.91162C5.75163 9.91162 5.25769 10.3959 5.25769 10.9933C5.25769 11.5907 5.75163 12.075 6.36093 12.075Z"
				fill="#0055A3" />
		</svg>

	</div>
</template>

<style scoped>

</style>